//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import * as tempListApi from '@/api/tempListApi.js';
export default {
  data: function data() {
    return {
      loading: false,
      visible: false,
      pram: {}
    };
  },
  props: {
    bindType: {
      // 打标类型 0: 订单列表打标 1: 三方订单打标
      type: [Number, String],
      default: 0
    }
  },
  mounted: function mounted() {
    this.pram = {};
  },
  methods: {
    openInit: function openInit(orderNo, skuName, tagRemark) {
      this.pram = {
        orderNo: orderNo,
        name: skuName,
        tips: tagRemark
      };
      this.visible = true;
    },
    handerSubmit: function handerSubmit() {
      var _this = this;
      this.loading = true;
      tempListApi.sendOrderMsg(this.pram).then(function (data) {
        _this.$message.success('操作成功');
        _this.loading = false;
        _this.visible = false;
        _this.$emit('doRefresh');
      }).catch(function () {
        _this.loading = false;
      });
    },
    closeEdit: function closeEdit() {
      this.visible = false;
    }
  }
};